// GENERATED by tools/build/gen-icon-data.mjs (npm run gen:icon-data) from the PHP catalogs.
// CustomNamedIcon — enchantment/ability mechanic icons (icon-only).
import type { IconMap } from '../types';

export const CUSTOM_NAMED_ICONS: IconMap = {
	"ability_does_not_work_on_armor_type": {
		"file": "ability_does_not_work_on_armor_type",
		"tooltip": "Effect does not apply if target item armor type matches"
	},
	"ability_does_not_work_on_if_weapon_property_exists": {
		"file": "ability_does_not_work_on_if_weapon_property_exists",
		"tooltip": "Effect does not apply if target item has weapon property"
	},
	"ability_does_not_work_on_weapon_category": {
		"file": "ability_does_not_work_on_weapon_category",
		"tooltip": "Effect does not apply if target item weapon category matches"
	},
	"ability_does_not_work_on_weapon_classification": {
		"file": "ability_does_not_work_on_weapon_classification",
		"tooltip": "Effect does not apply if target item weapon classification matches"
	},
	"ability_does_not_work_on_weapon_type": {
		"file": "ability_does_not_work_on_weapon_type",
		"tooltip": "Effect does not apply if target item weapon type matches"
	},
	"ability_only_works_against_size_category_number_above": {
		"file": "ability_only_works_against_size_category_number_above",
		"tooltip": "Target size must be anchor (caster rank + N) and larger categories"
	},
	"ability_only_works_against_size_category_number_below": {
		"file": "ability_only_works_against_size_category_number_below",
		"tooltip": "Target size must be anchor (caster rank + N) and smaller categories"
	},
	"ability_resets_long_rest": {
		"file": "ability_resets_long_rest",
		"tooltip": "Ability Resets After a Long Rest"
	},
	"ability_works_only_on_armor_type": {
		"file": "ability_works_only_on_armor_type",
		"tooltip": "Effect only applies if target item armor type matches"
	},
	"ability_works_only_on_if_weapon_property_exists": {
		"file": "ability_works_only_on_if_weapon_property_exists",
		"tooltip": "Effect only applies if target item has weapon property"
	},
	"ability_works_only_on_weapon_category": {
		"file": "ability_works_only_on_weapon_category",
		"tooltip": "Effect only applies if target item weapon category matches"
	},
	"ability_works_only_on_weapon_classification": {
		"file": "ability_works_only_on_weapon_classification",
		"tooltip": "Effect only applies if target item weapon classification matches"
	},
	"ability_works_only_on_weapon_type": {
		"file": "ability_works_only_on_weapon_type",
		"tooltip": "Effect only applies if target item weapon type matches"
	},
	"adv": {
		"file": "adv",
		"tooltip": "Advantage"
	},
	"adv_2": {
		"file": "adv_2",
		"tooltip": "Advantage | 2 Stacks"
	},
	"adv_3": {
		"file": "adv_3",
		"tooltip": "Advantage | 3 Stacks"
	},
	"adv_4": {
		"file": "adv_4",
		"tooltip": "Advantage | 4 Stacks"
	},
	"arcane_fletcher": {
		"file": "arcane_fletcher",
		"tooltip": "Arcane Fletcher - bind a spell scroll to an arrow; a hit releases the spell at the target"
	},
	"attack_rolls_adv": {
		"file": "attack_rolls_adv",
		"tooltip": "Attack Rolls ADV"
	},
	"attack_rolls_against_adv": {
		"file": "attack_rolls_against_adv",
		"tooltip": "Attack Rolls AGAINST ADV"
	},
	"attack_rolls_against_dis": {
		"file": "attack_rolls_against_dis",
		"tooltip": "Attack Rolls AGAINST DIS"
	},
	"attack_rolls_dis": {
		"file": "attack_rolls_dis",
		"tooltip": "Attack Rolls DIS"
	},
	"cost_gp": {
		"file": "cost_gp",
		"tooltip": "Cost (gp)"
	},
	"counterspell_against_dis": {
		"file": "counterspell_against_dis",
		"tooltip": "Counterspell Against DIS - enemies trying to Counterspell your next cast roll at this many stacks of Disadvantage (consumed on cast)"
	},
	"daily_cost_gp": {
		"file": "daily_cost_gp",
		"tooltip": "Daily Cost (gp)"
	},
	"damage_type_if_hit_is_natural_20": {
		"file": "triggers_on_critical_hit",
		"tooltip": "If Damage Type 1 → Natural 20"
	},
	"damage_type_roll_1_becomes_2": {
		"file": "damage_type_roll_1_becomes_2",
		"tooltip": "Damage Roll(s) of 1 become 2"
	},
	"damage_type_roll_1_is_rerolled": {
		"file": "damage_type_roll_1_is_rerolled",
		"tooltip": "Damage Roll(s) of 1 are REROLLED once"
	},
	"defense_roll_adv": {
		"file": "defense_roll_adv",
		"tooltip": "ALL Defensive Rolls have ADV"
	},
	"defense_roll_adv_vs_spells": {
		"file": "contesting_roll_adv_vs_spells",
		"tooltip": "Defensive Rolls ADV vs Spells/Magic"
	},
	"defense_roll_adv_vs_status_effect": {
		"file": "defense_roll_adv_vs_status_effect",
		"tooltip": "Saving Throw ADV vs Status Effect"
	},
	"defense_roll_dis": {
		"file": "defense_roll_dis",
		"tooltip": "ALL Defensive Rolls have DIS"
	},
	"defense_roll_dis_vs_status_effect": {
		"file": "defense_roll_dis_vs_status_effect",
		"tooltip": "Defensive Roll DIS vs Status Effect"
	},
	"dis": {
		"file": "dis",
		"tooltip": "Disadvantage"
	},
	"dis_2": {
		"file": "dis_2",
		"tooltip": "Disadvantage | 2 Stacks"
	},
	"dis_3": {
		"file": "dis_3",
		"tooltip": "Disadvantage | 3 Stacks"
	},
	"dis_4": {
		"file": "dis_4",
		"tooltip": "Disadvantage | 4 Stacks"
	},
	"effect_ends_on_end_of_caster_next_turn": {
		"file": "effect_ends_on_end_of_caster_next_turn",
		"tooltip": "Effect ENDS → END of CASTER'S NEXT turn"
	},
	"effect_ends_on_start_of_caster_next_turn": {
		"file": "effect_ends_on_start_of_caster_next_turn",
		"tooltip": "Effect ENDS → START of CASTER'S NEXT turn"
	},
	"effect_ends_on_target_end_of_turn": {
		"file": "effect_ends_on_target_end_of_turn",
		"tooltip": "Effect ENDS → END of TARGET'S Turn"
	},
	"effect_ends_on_target_start_of_turn": {
		"file": "effect_ends_on_target_start_of_turn",
		"tooltip": "Effect ENDS → START of TARGET'S Turn"
	},
	"effect_occurs_on_move_action": {
		"file": "effect_occurs_on_move_action",
		"tooltip": "Effect Occurs → Move Action"
	},
	"effect_starts_on_target_end_of_turn": {
		"file": "effect_starts_on_target_end_of_turn",
		"tooltip": "Effect STARTS → END of TARGET'S Turn"
	},
	"effect_starts_on_target_start_of_turn": {
		"file": "effect_starts_on_target_start_of_turn",
		"tooltip": "Effect STARTS → START of TARGET'S Turn"
	},
	"enchantment_armor_classification": {
		"file": "enchantment_armor_classification",
		"tooltip": "Enchantment Restriction - Armor Classification"
	},
	"enchantment_armor_type": {
		"file": "enchantment_armor_type",
		"tooltip": "Enchantment Restriction - Armor Type"
	},
	"enchantment_equipment_slot": {
		"file": "enchantment_equipment_slot",
		"tooltip": "Enchantment Restriction - Equipment Slot"
	},
	"enchantment_instrument_classification": {
		"file": "enchantment_instrument_classification",
		"tooltip": "Enchantment Restriction - Instrument Classification"
	},
	"enchantment_item_type": {
		"file": "enchantment_item_type",
		"tooltip": "Enchantment Restriction - Item Type"
	},
	"enchantment_not_armor_classification": {
		"file": "enchantment_not_armor_classification",
		"tooltip": "Enchantment Restriction - NOT Armor Classification"
	},
	"enchantment_not_armor_type": {
		"file": "enchantment_not_armor_type",
		"tooltip": "Enchantment Restriction - NOT Armor Type"
	},
	"enchantment_not_equipment_slot": {
		"file": "enchantment_not_equipment_slot",
		"tooltip": "Enchantment Restriction - NOT Equipment Slot"
	},
	"enchantment_not_instrument_classification": {
		"file": "enchantment_not_instrument_classification",
		"tooltip": "Enchantment Restriction - NOT Instrument Classification"
	},
	"enchantment_not_item_type": {
		"file": "enchantment_not_item_type",
		"tooltip": "Enchantment Restriction - NOT Item Type"
	},
	"enchantment_not_weapon_category": {
		"file": "enchantment_not_weapon_category",
		"tooltip": "Enchantment Restriction - NOT Weapon Category"
	},
	"enchantment_not_weapon_classification": {
		"file": "enchantment_not_weapon_classification",
		"tooltip": "Enchantment Restriction - NOT Weapon Classification"
	},
	"enchantment_not_weapon_type": {
		"file": "enchantment_not_weapon_type",
		"tooltip": "Enchantment Restriction - NOT Weapon Type"
	},
	"enchantment_weapon_category": {
		"file": "enchantment_weapon_category",
		"tooltip": "Enchantment Restriction - Weapon Category"
	},
	"enchantment_weapon_classification": {
		"file": "enchantment_weapon_classification",
		"tooltip": "Enchantment Restriction - Weapon Classification"
	},
	"enchantment_weapon_type": {
		"file": "enchantment_weapon_type",
		"tooltip": "Enchantment Restriction - Weapon Type"
	},
	"encounter_amb": {
		"file": "encounter_amb",
		"tooltip": "Encounter Ambience"
	},
	"encounter_amb_night": {
		"file": "encounter_amb_night",
		"tooltip": "Encounter Ambience - Night"
	},
	"encounter_amb_weather": {
		"file": "encounter_amb_weather",
		"tooltip": "Encounter Ambience - Weather"
	},
	"fixed_dc": {
		"file": "fixed_dc",
		"tooltip": "Fixed DC"
	},
	"healing_roll_1_becomes_2": {
		"file": "healing_roll_1_becomes_2",
		"tooltip": "Healing Roll(s) of 1 become 2"
	},
	"healing_roll_1_is_rerolled": {
		"file": "healing_roll_reroll_1s_and_2s",
		"tooltip": "Healing Roll(s) of 1 are REROLLED once"
	},
	"healing_roll_reroll_1s_and_2s": {
		"file": "healing_roll_reroll_1s_and_2s",
		"tooltip": "Healing Roll(s) of 1 and 2 are REROLLED once"
	},
	"if_armor_type_equipped_active": {
		"file": "if_armor_type_equipped_active",
		"tooltip": "Ability active if wearing armor type"
	},
	"if_armor_type_equipped_not_active": {
		"file": "if_armor_type_equipped_not_active",
		"tooltip": "Ability NOT active if wearing armor type"
	},
	"if_environment_active": {
		"file": "if_environment_active",
		"tooltip": "Ability Only Works while Environment is Active"
	},
	"if_environment_not_active": {
		"file": "if_environment_not_active",
		"tooltip": "Ability Only Works while Environment is NOT Active"
	},
	"if_weapon_category_equipped_active": {
		"file": "if_weapon_category_equipped_active",
		"tooltip": "Ability active if weapon category equipped"
	},
	"if_weapon_category_equipped_not_active": {
		"file": "if_weapon_category_equipped_not_active",
		"tooltip": "Ability NOT active if weapon category equipped"
	},
	"if_weapon_classification_equipped_active": {
		"file": "if_weapon_classification_equipped_active",
		"tooltip": "Ability active if weapon classification equipped"
	},
	"if_weapon_classification_equipped_not_active": {
		"file": "if_weapon_classification_equipped_not_active",
		"tooltip": "Ability NOT active if weapon classification equipped"
	},
	"if_weapon_has_property_equipped_active": {
		"file": "if_weapon_has_property_equipped_active",
		"tooltip": "Ability active if weapon property equipped"
	},
	"if_weapon_has_property_equipped_not_active": {
		"file": "if_weapon_has_property_equipped_not_active",
		"tooltip": "Ability NOT active if weapon property equipped"
	},
	"in_combat_time_control": {
		"file": "in_combat_time_control",
		"tooltip": "Turn Controls Disabled: In Combat"
	},
	"language_cannot_speak": {
		"file": "language_cannot_speak",
		"tooltip": "Can understand languages, but cannot speak"
	},
	"luck_persists_after_long_rest": {
		"file": "luck_persists_after_long_rest",
		"tooltip": "Luck Does Not Reset After a Long Rest"
	},
	"next_attack_against_adv": {
		"file": "next_attack_against_adv",
		"tooltip": "Next Attack Against has ADV"
	},
	"next_attack_against_dis": {
		"file": "next_attack_against_dis",
		"tooltip": "Next Attack Against has DIS"
	},
	"next_attack_roll_adv": {
		"file": "next_attack_roll_adv",
		"tooltip": "Next Attack Roll ADV"
	},
	"next_attack_roll_against_adv": {
		"file": "next_attack_roll_against_adv",
		"tooltip": "Next Attack Against ADV"
	},
	"next_attack_roll_against_dis": {
		"file": "next_attack_roll_against_dis",
		"tooltip": "Next Attack Against DIS"
	},
	"next_attack_roll_dis": {
		"file": "next_attack_roll_dis",
		"tooltip": "Next Attack DIS"
	},
	"next_contesting_roll_adv": {
		"file": "next_contesting_roll_adv",
		"tooltip": "Next Contesting Roll ADV"
	},
	"next_contesting_roll_dis": {
		"file": "next_contesting_roll_dis",
		"tooltip": "Next Contesting Roll DIS"
	},
	"next_healing_roll_adv": {
		"file": "next_healing_roll_adv",
		"tooltip": "Next Healing Roll has ADV"
	},
	"next_healing_roll_against_adv": {
		"file": "next_healing_roll_against_adv",
		"tooltip": "Next Healing Roll AGAINST has ADV"
	},
	"next_healing_roll_against_dis": {
		"file": "next_healing_roll_against_dis",
		"tooltip": "Next Healing Roll AGAINST has DIS"
	},
	"next_healing_roll_dis": {
		"file": "next_healing_roll_dis",
		"tooltip": "Next Healing Roll has DIS"
	},
	"next_skill_roll_adv": {
		"file": "next_skill_roll_adv",
		"tooltip": "Next Skill Roll ADV"
	},
	"next_skill_roll_dis": {
		"file": "next_skill_roll_dis",
		"tooltip": "Next Skill Roll DIS"
	},
	"next_spell_aoe_changed_by_percentage": {
		"file": "next_spell_aoe_changed_by_percentage",
		"tooltip": "Next Spell AOE Size Change % - your next AOE spell's dimensions each grow by this percent, rounded down to the nearest 5 ft (consumed on cast)"
	},
	"next_spell_aoe_effect_duplicated": {
		"file": "next_spell_aoe_effect_duplicated",
		"tooltip": "Next Spell AOE Effect Duplicated - your next AOE spell resolves its effect twice (consumed on cast)"
	},
	"next_spell_ap_override": {
		"file": "next_spell_ap_override",
		"tooltip": "Next Spell AP Override - your next spell costs at most this many AP to cast (0 = free; consumed on cast)"
	},
	"next_spell_bounce_cast": {
		"file": "next_spell_bounce_cast",
		"tooltip": "Next Spell Bounces - your next single-target attack-roll spell bounces 10 ft to an adjacent second target, reusing the same attack roll (consumed on cast)"
	},
	"next_spell_concentration_uncapped": {
		"file": "next_spell_concentration_uncapped",
		"tooltip": "Next Concentration Spell Endures - your next concentration spell lasts as long as you hold concentration, ignoring its duration cap (consumed on cast)"
	},
	"next_spell_damage_dice_changed_by_percentage": {
		"file": "next_spell_damage_dice_changed_by_percentage",
		"tooltip": "Next Spell Damage Dice Change % - your next spell rolls this percent more damage dice, rounded to the nearest whole die (consumed on cast)"
	},
	"next_spell_damage_type_choice": {
		"file": "next_spell_damage_type_choice",
		"tooltip": "Next Spell Damage Type Choice - pick the damage type of your next damaging spell (allowed types listed on this item; none listed = any; consumed on cast)"
	},
	"next_spell_hits_opposing_team_only": {
		"file": "next_spell_hits_opposing_team_only",
		"tooltip": "Next AOE Spell Spares Allies - your next AOE spell affects only opposing-team creatures (consumed on cast)"
	},
	"next_spell_mana_discount": {
		"file": "next_spell_mana_discount",
		"tooltip": "Next Spell Mana Discount - your next mana-paying spell costs this much less Mana (consumed on cast)"
	},
	"next_spell_melee_attack_roll_adv": {
		"file": "next_spell_melee_attack_roll_adv",
		"tooltip": "Next Spell Melee Attack Roll ADV"
	},
	"next_spell_melee_attack_roll_against_adv": {
		"file": "next_spell_melee_attack_roll_against_adv",
		"tooltip": "Next Spell Melee Attack Roll AGAINST has ADV"
	},
	"next_spell_melee_attack_roll_against_dis": {
		"file": "next_spell_melee_attack_roll_against_dis",
		"tooltip": "Next Spell Melee Attack Roll AGAINST has DIS"
	},
	"next_spell_melee_attack_roll_dis": {
		"file": "next_spell_melee_attack_roll_dis",
		"tooltip": "Next Spell Melee Attack Roll DIS"
	},
	"next_spell_paoe_applied_to_targets": {
		"file": "next_spell_paoe_applied_to_targets",
		"tooltip": "Next Spell Zone Rider - this follows-target zone envelops every target affected by your next spell (consumed on cast)"
	},
	"next_spell_range_multiplier": {
		"file": "next_spell_range_multiplier",
		"tooltip": "Next Spell Range Multiplier - your next spell casts at this multiple of its normal range (consumed on cast; not Self-range spells)"
	},
	"next_spell_ranged_attack_roll_adv": {
		"file": "next_spell_ranged_attack_roll_adv",
		"tooltip": "Next Spell Ranged Attack Roll ADV"
	},
	"next_spell_ranged_attack_roll_against_adv": {
		"file": "next_spell_ranged_attack_roll_against_adv",
		"tooltip": "Next Spell Ranged Attack Roll AGAINST has ADV"
	},
	"next_spell_ranged_attack_roll_against_dis": {
		"file": "next_spell_ranged_attack_roll_against_dis",
		"tooltip": "Next Spell Ranged Attack Roll AGAINST has DIS"
	},
	"next_spell_ranged_attack_roll_dis": {
		"file": "next_spell_ranged_attack_roll_dis",
		"tooltip": "Next Spell Ranged Attack Roll DIS"
	},
	"next_spell_self_range_becomes_reach": {
		"file": "next_spell_self_range_becomes_reach",
		"tooltip": "Next Self Spell Reaches - your next Self-range spell (no AOE) can target a creature within Reach instead (consumed on cast)"
	},
	"next_spell_target_opportunity_attack": {
		"file": "next_spell_target_opportunity_attack",
		"tooltip": "Next Spell Target Opportunity Attack - every target affected by your next spell can immediately make an Opportunity Attack against a foe in reach (consumed on cast)"
	},
	"next_spell_target_rider": {
		"file": "next_spell_target_rider",
		"tooltip": "Next Spell Target Rider - every target affected by your next spell also faces this item's secondary contest (consumed on cast)"
	},
	"next_spell_twin_cast": {
		"file": "next_spell_twin_cast",
		"tooltip": "Next Spell Twins - your next direct single-target spell may be cast at two targets (consumed on cast)"
	},
	"next_spell_upcast_levels": {
		"file": "next_spell_upcast_levels",
		"tooltip": "Next Spell Free Upcast Levels - your next upcastable spell resolves this many levels higher at no extra Mana (consumed on cast)"
	},
	"next_weapon_melee_attack_roll_adv": {
		"file": "next_weapon_melee_attack_roll_adv",
		"tooltip": "Next Weapon Melee Attack Roll ADV"
	},
	"next_weapon_melee_attack_roll_against_adv": {
		"file": "next_weapon_melee_attack_roll_against_adv",
		"tooltip": "Next Weapon Melee Attack Roll AGAINST has ADV"
	},
	"next_weapon_melee_attack_roll_against_dis": {
		"file": "next_weapon_melee_attack_roll_against_dis",
		"tooltip": "Next Weapon Melee Attack Roll AGAINST has DIS"
	},
	"next_weapon_melee_attack_roll_dis": {
		"file": "next_weapon_melee_attack_roll_dis",
		"tooltip": "Next Weapon Melee Attack Roll DIS"
	},
	"next_weapon_ranged_attack_roll_adv": {
		"file": "next_weapon_ranged_attack_roll_adv",
		"tooltip": "Next Weapon Ranged Attack Roll ADV"
	},
	"next_weapon_ranged_attack_roll_against_adv": {
		"file": "next_weapon_ranged_attack_roll_against_adv",
		"tooltip": "Next Weapon Ranged Attack Roll AGAINST has ADV"
	},
	"next_weapon_ranged_attack_roll_against_dis": {
		"file": "next_weapon_ranged_attack_roll_against_dis",
		"tooltip": "Next Weapon Ranged Attack Roll AGAINST has DIS"
	},
	"next_weapon_ranged_attack_roll_dis": {
		"file": "next_weapon_ranged_attack_roll_dis",
		"tooltip": "Next Weapon Ranged Attack Roll DIS"
	},
	"recharge_range_begin": {
		"file": "recharge_range_begin",
		"tooltip": "Ability Resets (d6)"
	},
	"recharge_range_ends": {
		"file": "recharge_range_ends",
		"tooltip": "Ability Recharges | Range End (d6)"
	},
	"requires_equipped_item": {
		"file": "requires_equipped_item",
		"tooltip": "Requires Equipped Items (all)"
	},
	"requires_reagent": {
		"file": "requires_reagent",
		"tooltip": "Requires Reagents"
	},
	"reroll_damage_die_1_once_adv": {
		"file": "reroll_damage_die_1_once_adv",
		"tooltip": "ONE damage die is rolled with ADV"
	},
	"reroll_damage_die_1_once_dis": {
		"file": "reroll_damage_die_1_once_dis",
		"tooltip": "ONE damage die is rolled with DIS"
	},
	"ritual_spell_mana_discount": {
		"file": "ritual_spell_mana_discount",
		"tooltip": "Ritual Spell Mana Discount - cast a ritual spell in normal time for less Mana (spends a charge)"
	},
	"short_rest_0": {
		"file": "short_rest_0",
		"tooltip": "Short Rest: No Charges Left"
	},
	"short_rest_1": {
		"file": "short_rest_1",
		"tooltip": "Short Rest: 1 Left"
	},
	"short_rest_2": {
		"file": "short_rest_2",
		"tooltip": "Short Rest: 2 Left"
	},
	"skill_tier_0": {
		"file": "skill_tier_0",
		"tooltip": "ST 0 | 0 SP | DIS"
	},
	"skill_tier_1": {
		"file": "skill_tier_1",
		"tooltip": "ST 1 | 1 SP | d4"
	},
	"skill_tier_10": {
		"file": "skill_tier_10",
		"tooltip": "ST 10 | 28 SP | d13"
	},
	"skill_tier_11": {
		"file": "skill_tier_11",
		"tooltip": "ST 11 | 40 SP | d14"
	},
	"skill_tier_12": {
		"file": "skill_tier_12",
		"tooltip": "ST 12 | 50 SP | d15"
	},
	"skill_tier_13": {
		"file": "skill_tier_13",
		"tooltip": "ST 13 | 60 SP | d16"
	},
	"skill_tier_14": {
		"file": "skill_tier_14",
		"tooltip": "ST 14 | 80 SP | d17"
	},
	"skill_tier_15": {
		"file": "skill_tier_15",
		"tooltip": "ST 15 | 100 SP | d18"
	},
	"skill_tier_16": {
		"file": "skill_tier_16",
		"tooltip": "ST 16 | 120 SP | d19"
	},
	"skill_tier_17": {
		"file": "skill_tier_17",
		"tooltip": "ST 17 | 140 SP | d20"
	},
	"skill_tier_18": {
		"file": "skill_tier_18",
		"tooltip": "ST 18 | 160 SP | d21"
	},
	"skill_tier_19": {
		"file": "skill_tier_19",
		"tooltip": "ST 19 | 180 SP | d22"
	},
	"skill_tier_2": {
		"file": "skill_tier_2",
		"tooltip": "ST 2 | 4 SP | d5"
	},
	"skill_tier_20": {
		"file": "skill_tier_20",
		"tooltip": "ST 20 | 200 SP | d23"
	},
	"skill_tier_21": {
		"file": "skill_tier_21",
		"tooltip": "ST 21 | 220 SP | d24"
	},
	"skill_tier_22": {
		"file": "skill_tier_22",
		"tooltip": "ST 22 | 240 SP | d25"
	},
	"skill_tier_23": {
		"file": "skill_tier_23",
		"tooltip": "ST 23 | 260 SP | d26"
	},
	"skill_tier_24": {
		"file": "skill_tier_24",
		"tooltip": "ST 24 | 280 SP | d27"
	},
	"skill_tier_25": {
		"file": "skill_tier_25",
		"tooltip": "ST 25 | 300 SP | d28"
	},
	"skill_tier_3": {
		"file": "skill_tier_3",
		"tooltip": "ST 3 | 7 SP | d6"
	},
	"skill_tier_4": {
		"file": "skill_tier_4",
		"tooltip": "ST 4 | 10 SP | d7"
	},
	"skill_tier_5": {
		"file": "skill_tier_5",
		"tooltip": "ST 5 | 13 SP | d8"
	},
	"skill_tier_6": {
		"file": "skill_tier_6",
		"tooltip": "ST 6 | 16 SP | d9"
	},
	"skill_tier_7": {
		"file": "skill_tier_7",
		"tooltip": "ST 7 | 19 SP | d10"
	},
	"skill_tier_8": {
		"file": "skill_tier_8",
		"tooltip": "ST 8 | 22 SP | d11"
	},
	"skill_tier_9": {
		"file": "skill_tier_9",
		"tooltip": "ST 9 | 25 SP | d12"
	},
	"spell_upcast_increase_aoe_ft": {
		"file": "spell_upcast_increase_aoe_ft",
		"tooltip": "Upcasted Spell Increase AOE Ft"
	},
	"steal_target_held_item": {
		"file": "steal_target_held_item",
		"tooltip": "Steal the Target's Held Weapon"
	},
	"swarm_width_lanes": {
		"file": "swarm_width_lanes",
		"tooltip": "Swarm Width Lanes - extra horizontal lanes the swarm token occupies at full strength"
	},
	"triggers_after_long_rest": {
		"file": "triggers_after_long_rest",
		"tooltip": "Effect triggers after long rest"
	},
	"triggers_on_attack_roll_against": {
		"file": "triggers_on_attack_roll_against",
		"tooltip": "Effect triggers after an attack roll is made against the caster."
	},
	"triggers_on_attack_roll_weapon_melee_against": {
		"file": "triggers_on_attack_roll_weapon_melee_against",
		"tooltip": "Effect triggers after a melee attack roll is made against the caster."
	}
};
